export default __webpack_public_path__ + "static/media/icon-user.75eb2abf.svg";